import { AppStoreState, TDispatchAction } from '.'
import {
    ACTION_SET_IS_MOBILE,
    ACTION_SET_USER,
    ACTION_SET_LANGUAGE,
    ACTION_SET_COMPANY_LIST,
    ACTION_SET_COMPANY_FOLLOW,
    ACTION_SET_SEARCH_ROBOT, ACTION_SET_COMPANY_INDUSTRY_SELECTION
} from './actions'

const reducer = (state: AppStoreState, action: TDispatchAction) => {
    switch (action.type) {
        case ACTION_SET_USER: {
            return {
                ...state,
                user: action.payload
            }
        }
        case ACTION_SET_IS_MOBILE: {
            return {
                ...state,
                isMobile: action.payload || false
            }
        }
        case ACTION_SET_LANGUAGE: {
            return {
                ...state,
                langCode: action.payload
            }
        }
        case ACTION_SET_COMPANY_INDUSTRY_SELECTION: {
            return {
                ...state,
                companyIndustries: [state.companyIndustries[0], ...action.payload]
            }
        }
        case ACTION_SET_COMPANY_LIST:  {
            return {
                ...state,
                companyList: action.payload
            }
        }
        case ACTION_SET_COMPANY_FOLLOW: {
            const companyId: number = action.payload.companyId
            const isFollow: number = action.payload.isFollow
            const followCount: number = action.payload.followCount
            // Loop through company list group
            const stateCompanyList = state.companyList.map((companyGroup) => {
                let companyItemGroup = Object.assign({}, companyGroup)
                // Loop through company list in group
                companyItemGroup.data = companyItemGroup.data.map((companyItem) => {
                    let copiedCompanyItem = Object.assign({}, companyItem)
                    // Find match companyId
                    if (copiedCompanyItem.companyId === companyId) {
                        copiedCompanyItem.isFollowed = isFollow
                        copiedCompanyItem.followerCount = followCount
                    }
                    return copiedCompanyItem
                })
                return companyItemGroup
            })
            return {
                ...state,
                companyList: stateCompanyList
            }
        }
        case ACTION_SET_SEARCH_ROBOT: {
            return {
                ...state,
                isRobot: action.payload
            }
        }
    }

    return state
}

export default reducer
